// src/components/PasswordResetModal.js

import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';

const PasswordResetModal = ({ client, onClose }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      await axios.put(
        `http://127.0.0.1:8000/admin/clients/${client.id}/password`,
        { new_password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Contrasena actualizada con exito.');
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al actualizar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    // Contenedor del Modal con overlay oscuro
    <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex justify-center items-center z-50 p-4">
      {/* Tarjeta del Modal */}
      <div className="glass-panel p-8 rounded-xl shadow-xl w-full max-w-lg animate-fade-up">
        <h2 className="text-2xl font-bold text-white mb-2">Restablecer Contraseña</h2>
        <p className="text-gray-400 mb-6">para <span className="font-bold">{client.name}</span></p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          
          {/* Campo Nueva Contraseña */}
          <div>
            <label htmlFor="new-password" className="block text-sm font-medium text-gray-300">
              Nueva Contraseña
            </label>
            <input 
              type="password" 
              id="new-password"
              value={newPassword} 
              onChange={(e) => setNewPassword(e.target.value)} 
              required 
              className="mt-1 block w-full p-3 bg-gray-700 text-white font-bold rounded-md border-gray-600 focus:ring-marizan-red focus:border-marizan-red"
            />
          </div>

          {/* Campo Confirmar Nueva Contraseña */}
          <div>
            <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-300">
              Confirmar Nueva Contraseña
            </label>
            <input 
              type="password" 
              id="confirm-password"
              value={confirmPassword} 
              onChange={(e) => setConfirmPassword(e.target.value)} 
              required 
              className="mt-1 block w-full p-3 bg-gray-700 text-white font-bold rounded-md border-gray-600 focus:ring-marizan-red focus:border-marizan-red"
            />
          </div>

          {error && <p className="text-red-300 bg-red-950/40 border border-red-900/60 rounded-lg px-3 py-2 text-sm text-center">{error}</p>}

          {/* Botones */}
          <div className="flex justify-end space-x-4 pt-4">
            <button 
              type="button" 
              onClick={onClose} 
              className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              disabled={loading}
              className="bg-marizan-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg transition-colors disabled:opacity-50"
            >
              {loading ? 'Guardando...' : 'Restablecer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetModal;